import { createFileRoute } from "@tanstack/react-router";
import DiagnosedDepressionAt50 from "@/pages/articles/DiagnosedDepressionAt50";
export const Route = createFileRoute("/diagnosed-with-depression-at-50")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title: "Diagnosed With Depression At 50 | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Depression at 50 is common and treatable. Learn about TMS, SAINT TMS, and treatment options for depression in your 50s in Coral Springs, FL.",
        },
        {
          property: "og:title",
          content: "Diagnosed With Depression At 50 | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Depression at 50 is common and treatable. Learn about TMS, SAINT TMS, and treatment options for depression in your 50s in Coral Springs, FL.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/diagnosed-with-depression-at-50",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/diagnosed-with-depression-at-50",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <DiagnosedDepressionAt50 />;
}
